import { TmnIconButton } from '@trumedianetworks/tmn-core-components/src/tmn-button/tmn-icon-button';
import { withRouting } from './route-base';

window.customElements.define('routed-icon-button', withRouting()(TmnIconButton));
